"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaBlockResponseToJSON = exports.RosettaBlockResponseFromJSONTyped = exports.RosettaBlockResponseFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function RosettaBlockResponseFromJSON(json) {
    return RosettaBlockResponseFromJSONTyped(json, false);
}
exports.RosettaBlockResponseFromJSON = RosettaBlockResponseFromJSON;
function RosettaBlockResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'block': !runtime_1.exists(json, 'block') ? undefined : _1.RosettaBlockFromJSON(json['block']),
        'other_transactions': !runtime_1.exists(json, 'other_transactions') ? undefined : (json['other_transactions'].map(_1.OtherTransactionIdentifierFromJSON)),
    };
}
exports.RosettaBlockResponseFromJSONTyped = RosettaBlockResponseFromJSONTyped;
function RosettaBlockResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'block': _1.RosettaBlockToJSON(value.block),
        'other_transactions': value.other_transactions === undefined ? undefined : (value.other_transactions.map(_1.OtherTransactionIdentifierToJSON)),
    };
}
exports.RosettaBlockResponseToJSON = RosettaBlockResponseToJSON;
//# sourceMappingURL=RosettaBlockResponse.js.map